import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { isVLibrasOculto, onVLibrasPrefChange } from "../../services/vlibrasPreferencia";

const VLIBRAS_SCRIPT_URL = "https://vlibras.gov.br/app/vlibras-plugin.js";

// Páginas onde o botão aparece - por enquanto só o feed de comunicados e a
// tela de um comunicado aberto (pedido do usuário, 2026-09-18: "inicialmente
// no feed de comunicados, depois podemos ver de expandir"). Pra expandir,
// só adicionar o prefixo aqui.
const PREFIXOS_VISIVEIS = ["/home", "/comunicado/"];

function rotaPermiteWidget(pathname) {
    return PREFIXOS_VISIVEIS.some(prefixo => pathname === prefixo || pathname.startsWith(prefixo));
}

// Widget oficial do governo (VLibras Widget) - traduz o TEXTO da página pra
// Libras via avatar 3D. Não traduz vídeo/áudio (isso não existe via widget,
// só via VLibras Vídeo, ferramenta manual separada com login gov.br próprio -
// ver conversa). Fica montado uma única vez em App.js (nunca desmonta entre
// navegações) e só alterna visibilidade por CSS conforme a rota - instanciar
// o widget de novo a cada remount duplicaria o botão/iframe internos.
export default function VLibrasWidget() {
    const location = useLocation();
    const [pronto, setPronto] = useState(!!window.VLibras);
    const [oculto, setOculto] = useState(isVLibrasOculto);
    const instanciado = useRef(false);

    // Preferência é trocada de outro componente (toggle no drawer,
    // LayoutBase.jsx) - reage em tempo real via evento, sem precisar recarregar
    // a página nem ligar os dois componentes por prop/contexto.
    useEffect(() => {
        return onVLibrasPrefChange(() => setOculto(isVLibrasOculto()));
    }, []);

    useEffect(() => {
        // Quem escondeu o ícone não paga o custo de baixar o script à toa -
        // só carrega quando realmente for exibir (aqui ou se a preferência
        // mudar pra "mostrar" depois, já que este efeito depende de `oculto`).
        if (oculto) return;

        if (window.VLibras) {
            setPronto(true);
            return;
        }
        const existente = document.querySelector(`script[src="${VLIBRAS_SCRIPT_URL}"]`);
        if (existente) {
            existente.addEventListener("load", () => setPronto(true));
            return;
        }
        const script = document.createElement("script");
        script.src = VLIBRAS_SCRIPT_URL;
        script.async = true;
        script.onload = () => setPronto(true);
        document.body.appendChild(script);
    }, [oculto]);

    useEffect(() => {
        if (!pronto || instanciado.current || !window.VLibras) return;
        new window.VLibras.Widget("https://vlibras.gov.br/app");
        instanciado.current = true;
    }, [pronto]);

    const visivel = rotaPermiteWidget(location.pathname) && !oculto;

    // O esconder de verdade é feito por CSS global (index.css, regra
    // "body.vlibras-hidden [vw]...") - o VLibras às vezes reposiciona seus
    // próprios elementos pra fora deste wrapper quando inicializa, então um
    // style inline só neste <div> não pegava o botão real a tempo (ver
    // comentário no index.css). A classe no body funciona não importa onde
    // o plugin tenha colocado os elementos.
    useEffect(() => {
        document.body.classList.toggle("vlibras-hidden", !visivel);
    }, [visivel]);

    return (
        <div vw="" className="enabled">
            <div vw-access-button="" className="active" />
            <div vw-plugin-wrapper="">
                <div className="vw-plugin-top-wrapper" />
            </div>
        </div>
    );
}
